import {switchFieldConstructor} from "scenes/cohort-filters/filter-configs/fieldContructors";
import {Category} from "scenes/cohort-filters/filter-configs/categories";

export const otherFields = {
    ...switchFieldConstructor({
        category: Category.OTHER,
        pathToValue: "anamnesis.haveAllergies",
        label: "anamnesis.allergies.title",
    }),
}
